module.exports = __webpack_public_path__ + "assets/img/eternia-39.9fff6bc2.jpg";